import { Trans } from '@lingui/react/macro'
import { restartLoginUrl } from './LoginPage'

export function LoginExpired() {
  return (
    <div className="flex flex-col gap-8">
      <h1 className="label-lg">
        <Trans>Login expired</Trans>
      </h1>
      <div>
        <Trans>
          Your login has timed out. Looks like you took a bit long to log in.
          Please try again!
        </Trans>
      </div>
      <a className="btn btn-primary" href={restartLoginUrl}>
        <Trans>Restart login</Trans>
      </a>
    </div>
  )
}
